const networkList = [
    {
        area: 'Gyeonggi-do',
        category: 'ct_warehouse',
        name: 'Sihwa MTV Warehouse',
        goods: 'general, bonded, pharmaceuticals',
        address:
            '23, Emtibeui 6-ro 18beon-gil, Danwon-gu, Ansan-si, Gyeonggi-do',
    },
    {
        area: 'Gyeonggi-do',
        category: 'ct_warehouse',
        name: 'South Cheongna Warehouse',
        goods: 'general',
        address: '28-23, Bukhang-ro, Seo-gu, Incheon',
    },
    {
        area: 'Gyeonggi-do',
        category: 'ct_warehouse',
        name: 'South Cheongna 2 Warehouse',
        goods: 'general',
        address: '45, Geonji-ro, Seo-gu, Incheon',
    },
    {
        area: 'Gyeonggi-do',
        category: 'ct_warehouse',
        name: 'North Cheongna Warehouse',
        goods: 'general',
        address: '47, Jeongseojin-ro, Seo-gu, Incheon',
    },
    {
        area: 'Gyeonggi-do',
        category: 'ct_warehouse',
        name: 'Incheon New Port Warehouse',
        goods: 'general, exclusive warehouse for customers',
        address: '866-7, Incheonsinhang-daero, Yeonsu-gu, Incheon',
    },
    {
        area: 'Gyeonggi-do',
        category: 'ct_warehouse',
        name: 'Incheon Airport Warehouse',
        goods: 'general, bonded, frozen storage, pharmaceuticals',
        address: '98-30, Gonghangdong-ro 296beon-gil, Jung-gu, Incheon',
    },
    {
        area: 'Gyeonggi-do',
        category: 'ct_warehouse',
        name: 'Yeongjong Warehouse',
        goods: 'general, bonded, exclusive warehouse for customers',
        address: '30, Yeongjongsunhwan-ro 900beon-gil, Jung-gu, Incheon',
    },
    {
        area: 'Gyeonggi-do',
        category: 'ct_warehouse',
        name: 'South Icheon Warehouse',
        goods: 'general, exclusive warehouse for customers',
        address: '256, Daewol-ro, Daewol-myeon, Icheon-si, Gyeonggi-do',
    },
    {
        area: 'Gyeonggi-do',
        category: 'ct_warehouse',
        name: 'West Icheon Warehouse',
        goods: 'general, frozen storage, pharmaceuticals',
        address:
            '113-60, Premium outlet-ro, Majang-myeon, Icheon-si, Gyeonggi-do',
    },
    {
        area: 'Gyeonggi-do',
        category: 'ct_warehouse',
        name: 'North Icheon Warehouse',
        goods: 'general, exclusive warehouse for customers',
        address: '501, Iyeo-ro, Baeksa-myeon, Icheon-si, Gyeonggi-do',
    },
    {
        area: 'Gyeonggi-do',
        category: 'ct_warehouse',
        name: 'Icheon 2 Warehouse',
        goods: 'general, exclusive warehouse for customers',
        address: '1894, Jinsangmi-ro, Icheon-si, Gyeonggi-do',
    },
    {
        area: 'Gyeonggi-do',
        category: 'ct_warehouse',
        name: 'Gmarket Dongtan Warehouse',
        goods: 'general, exclusive warehouse for customers',
        address: '48, Dongtanmullyu-ro, Hwaseong-si, Gyeonggi-do',
    },
    {
        area: 'Gyeonggi-do',
        category: 'ct_warehouse',
        name: 'Pyeongtaek Warehouse',
        goods: 'general, bonded, frozen storage, pharmaceuticals',
        address: '33, Seotan-ro, Jinwi-myeon, Pyeongtaek-si, Gyeonggi-do',
    },
    {
        area: 'Gyeonggi-do',
        category: 'ct_warehouse',
        name: 'Pyeongtaek DG Warehouse',
        goods: 'dangerous goods',
        address:
            '139, Wonhansan-gil, Cheongbuk-eup, Pyeongtaek-si, Gyeonggi-do',
    },
    {
        area: 'Gyeonggi-do',
        category: 'ct_warehouse',
        name: 'Pyeongtaek HUB',
        goods: 'bonded, exclusive warehouse for customers',
        address: '222, LG-ro, Jinwi-myeon, Pyeongtaek-si, Gyeonggi-do',
    },
    {
        area: 'Gyeonggi-do',
        category: 'ct_warehouse',
        name: 'Yongin Warehouse',
        goods: 'general',
        address:
            '1, Maengni-ro 2beon-gil, Wonsam-myeon, Cheoin-gu, Yongin-si, Gyeonggi-do',
    },
    {
        area: 'Gyeonggi-do',
        category: 'ct_warehouse',
        name: 'Anseong Warehouse',
        goods: 'general, frozen storage, pharmaceuticals',
        address: '75, Samjuk-ro, Samjuk-myeon, Anseong-si, Gyeonggi-do',
    },
    {
        area: 'Chungcheong-do',
        category: 'ct_warehouse',
        name: 'Eumseong Warehouse',
        goods: 'general, exclusive warehouse for customers',
        address:
            '68, Cheonpyeong-gil, Samseong-myeon, Eumseong-gun, Chungcheongbuk-do',
    },
    {
        area: 'Chungcheong-do',
        category: 'ct_warehouse',
        name: 'Cheonan Warehouse',
        goods: 'general, exclusive warehouse for customers',
        address:
            '111, Pungsesandan 3-ro, Pungse-myeon, Dongnam-gu, Cheonan-si, Chungcheongnam-do',
    },
    {
        area: 'Chungcheong-do',
        category: 'ct_warehouse',
        name: 'Cheonan 2 Warehouse',
        goods: 'general, exclusive warehouse for customers',
        address:
            '122, Daeheung 1-gil, Seongnam-myeon, Dongnam-gu, Cheonan-si, Chungcheongnam-do',
    },
    {
        area: 'Gwangju',
        category: 'ct_warehouse',
        name: 'Gwangju Warehouse',
        goods: 'general, bonded',
        address: '108, Pyeongdongsandan 7beon-ro, Gwangsan-gu, Gwangju',
    },
    {
        area: 'Gyeongsang-do',
        category: 'ct_warehouse',
        name: 'Ulsan Warehouse',
        goods: 'dangerous goods',
        address: '60, Sinhang-ro 716beon-gil, Nam-gu, Ulsan',
    },
    {
        area: 'Gyeongsang-do',
        category: 'ct_warehouse',
        name: 'Changwon HUB',
        goods: 'bonded, exclusive warehouse for customers',
        address: '5, Yuha-ro 59beon-gil, Gimhae-si, Gyeongsangnam-do',
    },
    {
        area: 'Gyeongsang-do',
        category: 'ct_warehouse',
        name: 'Gumi HUB',
        goods: 'bonded, exclusive warehouse for customers',
        address: '377, Sanho-daero, Gumi-si, Gyeongsangbuk-do',
    },
    {
        area: 'Gyeongsang-do',
        category: 'ct_etc',
        name: 'Gumi CY&CFS',
        goods: 'general',
        address:
            '204, Imcheonindeok-ro, Sandong-eup, Gumi-si, Gyeongsangbuk-do',
    },
    {
        area: 'Gyeongsang-do',
        category: 'ct_warehouse',
        name: 'Miryang Warehouse',
        goods: 'general, exclusive warehouse for customers',
        address: '91, Sapo-ro, Bubuk-myeon, Miryang-si, Gyeongsangnam-do',
    },
    {
        area: 'Gyeongsang-do',
        category: 'ct_warehouse',
        name: 'Jinju Warehouse',
        goods: 'general, exclusive warehouse for customers',
        address: '130, Yongbong-ro, Jisu-myeon, Jinju-si, Gyeongsangnam-do',
    },
    {
        area: 'Gyeongsang-do',
        category: 'ct_warehouse',
        name: 'Busan 2 Warehouse',
        goods: 'general, exclusive warehouse for customers',
        address: '343, Sinhang 8-ro, Jinhae-gu, Changwon-si, Gyeongsangnam-do',
    },
    {
        area: 'Gyeongsang-do',
        category: 'ct_warehouse',
        name: 'Busan New Port Warehouse',
        goods: 'general, bonded, dangerous goods, pharmaceuticals',
        address:
            '15-85, Sinhang 4-ro, Jinhae-gu, Changwon-si, Gyeongsangnam-do',
    },
    {
        area: 'Jeju-do',
        category: 'ct_warehouse',
        name: 'Jeju Warehouse',
        goods: 'general, exclusive warehouse for customers',
        address: '2706-27, Iljudong-ro, Gujwa-eup, Jeju-si, Jeju-do',
    },
    {
        area: 'Gyeonggi-do',
        category: 'ct_transport',
        name: 'Anyang Transport',
        goods: '',
        address: '48, Deokcheon-ro, Manan-gu, Anyang-si, Gyeonggi-do',
    },
    {
        area: 'Gyeongsang-do',
        category: 'ct_transport',
        name: 'Gumi Transport',
        goods: '',
        address: '89, Bisan-ro, Gumi-si, Gyeongsangbuk-do',
    },
    {
        area: 'Gyeongsang-do',
        category: 'ct_transport',
        name: 'Changwon Transport',
        goods: '',
        address: '96, Chasang-ro, Uichang-gu, Changwon-si, Gyeongsangnam-do',
    },
    {
        area: 'Gwangju',
        category: 'ct_transport',
        name: 'Naju Transport',
        goods: '',
        address: '278, Geonjae-ro, Naju-si, Jeollanam-do',
    },
    {
        area: 'Gwangju',
        category: 'ct_transport',
        name: 'Yeosu Transport',
        goods: '',
        address: '532, Jwasuyeong-ro, Yeosu-si, Jeollanam-do',
    },
    {
        area: 'Gwangju',
        category: 'ct_transport',
        name: 'Jeonju Transport',
        goods: '',
        address: '21-12, Jinbeodeul 3-gil, Deokjin-gu, Jeonju-si, Jeollabuk-do',
    },
    {
        area: 'Chungcheong-do',
        category: 'ct_transport',
        name: 'Daesan Transport',
        goods: '',
        address: '238, Myeongji 1-ro, Daesan-eup, Seosan-si, Chungcheongnam-do',
    },
    {
        area: 'Chungcheong-do',
        category: 'ct_transport',
        name: 'Cheonan Transport',
        goods: '',
        address:
            '387, Yeongok-gil, Ipjang-myeon, Seobuk-gu, Cheonan-si, Chungcheongnam-do',
    },
    {
        area: 'Chungcheong-do',
        category: 'ct_transport',
        name: 'Cheongju Transport',
        goods: '',
        address:
            '72, Jikji-daero 240beon-gil, Heungdeok-gu, Cheongju-si, Chungcheongbuk-do',
    },
    {
        area: 'Gyeongsang-do',
        category: 'ct_transport',
        name: 'Busan Transport',
        goods: '',
        address: '46, Chungjang-daero 9beon-gil, Jung-gu, Busan',
    },
    {
        area: 'Gyeongsang-do',
        category: 'ct_transport',
        name: 'Ulsan Transport',
        goods: '',
        address: '835, Onsan-ro, Nam-gu, Ulsan',
    },
];
